import React, { useState, useEffect } from "react";

import { datadogRum } from "@datadog/browser-rum";

import { WarehouseProvider } from "./WarehouseProvider";
// import { Snackbar, Fade } from "@mui/material";
import { PackageLookup } from "./PackageLookup";
import { useSteps } from "./useSteps";
import { Inventory } from "./Inventory";
import { Alerts } from "./Alerts";
import "./warehouse.css";

export const WarehouseApp = () => {
  const { StepComponent, props = {}, resetToPackageLookup } = useSteps();
  const [showInventory, setShowInventory] = useState(false);
  const [showAlerts, setShowAlerts] = useState(false);
  const [initialTrackingId, setInitialTrackingId] = useState(null);

  useEffect(() => {
    console.log("Start Session Replay");
    datadogRum.startSessionReplayRecording();
  }, []);

  // Clear initial tracking ID when component changes
  useEffect(() => {
    if (StepComponent && StepComponent !== PackageLookup) {
      setInitialTrackingId(null);
    }
  }, [StepComponent]);

  // Initialize with PackageLookup on mount
  useEffect(() => {
    if (!StepComponent) {
      resetToPackageLookup();
    }
  }, [StepComponent, resetToPackageLookup]);

  // const { successMessage } = props;

  // Determine which component to show
  const CurrentComponent = StepComponent || PackageLookup;

  return (
    <div className="warehouse-v2">
      <WarehouseProvider>
        {showInventory ? (
          <Inventory
            onBack={() => {
              setShowInventory(false);
              resetToPackageLookup();
            }}
            onAlertsClick={() => {
              setShowInventory(false);
              setShowAlerts(true);
            }}
            onRowClick={(trackingId) => {
              setInitialTrackingId(trackingId);
              setShowInventory(false);
              resetToPackageLookup();
            }}
          />
        ) : showAlerts ? (
          <Alerts
            onBack={() => {
              setShowAlerts(false);
              resetToPackageLookup();
            }}
            onInventoryClick={() => {
              setShowAlerts(false);
              setShowInventory(true);
            }}
            onRowClick={(trackingId) => {
              setInitialTrackingId(trackingId);
              setShowAlerts(false);
              resetToPackageLookup();
            }}
          />
        ) : (
          <CurrentComponent
            {...props}
            initialTrackingId={initialTrackingId}
            onInventoryClick={() => setShowInventory(true)}
            onAlertsClick={() => setShowAlerts(true)}
          />
        )}
        {/* <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
          TransitionComponent={Fade}
          open={Boolean(successMessage)}
          onClose={clear}
          autoHideDuration={5000}
          classes={{
            root: "opacity-0",
          }}
        >
          <div className="border-l-4 border-l-[#00CFA8] bg-[#00CFA8]/20 text-white p-4">
            {successMessage}
          </div>
        </Snackbar> */}
      </WarehouseProvider>
    </div>
  );
};
